export const CHECKOUT_URL =
  'https://senior-fitness-coach-pro.impultienda.ar/checkout'

export const BOX_IMG =
  'https://cdn.magicpatterns.com/uploads/ekh4ie8VmYdVf9yr85msj7/ChatGPT-Image-27-jul-2026_-03_41_55-p.m..webp'

export const PRODUCT_NAME = 'SENIOR FITNESS COACH PRO™'
